'use client';

import { Text } from '@chakra-ui/react';
import { Box, VStack } from '@medsimples/design-system/src/chakra';
import { Button } from '@medsimples/design-system/src/components';
import Email from '@public/icons/email/email';
import Phone from '@public/icons/phone/phone';

import NextLink from 'next/link';
import { useDesignTokens } from '../../providers/design_tokens_provider';
import LoginBackButton from './back_button';

export default function LoginMethodPage() {
  const tokens = useDesignTokens();
  return (
    <>
      <Box marginBottom={20}>
        <Text textAlign='center' fontSize='xl'>
          Escolha como deseja entrar
        </Text>
      </Box>
      <Box marginBottom={20}>
        <VStack spacing={5}>
          <Text textAlign='center' fontSize='md' color={tokens.text.gray.color}>
            Você receberá um código de verificação de 6 dígitos para poder
            acessar a plataforma.
          </Text>
          <Text textAlign='center' fontSize='md' color={tokens.text.gray.color}>
            <Text as='b'>Fique atento:</Text> ninguém te pedirá esse código!
          </Text>
        </VStack>
      </Box>

      <Box w='100%'>
        <VStack spacing={5}>
          <Button
            data-testid='email-button'
            colorScheme={tokens.button.primary.scheme}
            leftIcon={
              <Email color={tokens.text.white.color} width={28} height={28} />
            }
            href={'/signin?method=email'}
            as={NextLink}
          >
            <Text color={tokens.text.white.color}>Email</Text>
          </Button>
          <Button
            colorScheme={tokens.button.primary.scheme}
            data-testid='phone-button'
            leftIcon={
              <Phone color={tokens.text.white.color} width={28} height={28} />
            }
            href={'/signin?method=phone'}
            as={NextLink}
          >
            <Text color={tokens.text.white.color}>Telefone</Text>
          </Button>

          <LoginBackButton />
        </VStack>
      </Box>
    </>
  );
}
